import { createFileRoute } from '@tanstack/react-router'
import { ReportsGeneratePage } from '@/features/reports/components/ReportsGeneratePage'

export const Route = createFileRoute('/_auth/reports/generate')({
  component: ReportsGenerateRoute,
})

function ReportsGenerateRoute() {
  const userGroupId = 5

  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-2xl font-bold mb-6 uppercase tracking-wide">
        Reports - Generate
      </h1>
      <ReportsGeneratePage userGroupId={userGroupId} />
    </div>
  )
}
